/**
 * @since 7.1.0
 */
export enum EventSpan {
  /**
   * @since 7.1.0
   */
  THIS_EVENT,
  /**
   * @since 7.1.0
   */
  THIS_AND_FUTURE_EVENTS,
}
